/**
 * Stable CSS class names for E2E — MP cargo fee management.
 */
export const MPCFM = {
    page: 'mp-cargo-fee-management-page',
    shellPaper: 'mp-cargo-fee-management-page__shell',
    loadingSection: 'mp-cargo-fee-management-page__loading-section',
    breadcrumbSection: 'mp-cargo-fee-management-page__breadcrumb-section',
    tabsWrap: 'mp-cargo-fee-management-page__tabs-wrap',
    tabsRoot: 'mp-cargo-fee-management-page__tabs',
    tabList: 'mp-cargo-fee-management-page-input--tab-list',
    tabBulkUpload: 'mp-cargo-fee-management-page-input--tab-bulk-upload',
    tabPanelList: 'mp-cargo-fee-management-page__tab-panel-list',
    tabPanelBulkUpload: 'mp-cargo-fee-management-page__tab-panel-bulk-upload',

    listTabRoot: 'mp-cargo-fee-list-tab',
    listTabEmptyGate: 'mp-cargo-fee-list-tab__empty-gate',
    listTabEmptyPaper: 'mp-cargo-fee-list-tab__empty-paper',
    listTabEmptyCompanyField: 'mp-cargo-fee-list-tab__empty-company-field',
    inputSelectListTabCompany: 'mp-cargo-fee-list-tab-input--select-company',
    inputButtonListTabFilter: 'mp-cargo-fee-list-tab-input--button-filter',
    listTabToolbarBack: 'mp-cargo-fee-list-tab__toolbar-back',
    inputButtonListTabBack: 'mp-cargo-fee-list-tab-input--button-back',
    listTabToolbarActions: 'mp-cargo-fee-list-tab__toolbar-actions',
    inputButtonListTabAdd: 'mp-cargo-fee-list-tab-input--button-add',
    inputButtonListTabExportExcel: 'mp-cargo-fee-list-tab-input--button-export-excel',
    listTabGridWrap: 'mp-cargo-fee-list-tab__grid-wrap',
    listTabCostHeader: 'mp-cargo-fee-list-datagrid-cost-header',
    inputIconCostInfo: 'mp-cargo-fee-list-datagrid-input--icon-cost-info',
    listTabDatagridActionsCell: 'mp-cargo-fee-list-datagrid-actions-cell',
    inputButtonRowEdit: 'mp-cargo-fee-list-datagrid-input--button-row-edit',
    inputButtonRowDelete: 'mp-cargo-fee-list-datagrid-input--button-row-delete',

    feeDrawerBody: 'mp-cargo-fee-drawer',
    feeDrawerFields: 'mp-cargo-fee-drawer__fields',
    feeDrawerFieldCompany: 'mp-cargo-fee-drawer__field-company',
    inputSelectDrawerCompany: 'mp-cargo-fee-drawer-input--select-company',
    inputTextDrawerDesi: 'mp-cargo-fee-drawer-input--text-desi',
    inputTextDrawerCost: 'mp-cargo-fee-drawer-input--text-cost',
    feeDrawerDateSection: 'mp-cargo-fee-drawer__date-section',
    feeDrawerDateRangeWrap: 'mp-cargo-fee-drawer__date-range-wrap',
    feeDrawerActionsRow: 'mp-cargo-fee-drawer__actions-row',
    inputButtonDrawerClear: 'mp-cargo-fee-drawer-input--button-clear',
    inputButtonDrawerSave: 'mp-cargo-fee-drawer-input--button-save',

    bulkTabRoot: 'mp-cargo-fee-bulk-tab',
    bulkTabTitle: 'mp-cargo-fee-bulk-tab__title',
    bulkTabSubtitle: 'mp-cargo-fee-bulk-tab__subtitle',
    bulkTabCompanyField: 'mp-cargo-fee-bulk-tab__company-field',
    inputSelectBulkTabCompany: 'mp-cargo-fee-bulk-tab-input--select-company',
    bulkTabRulesPaper: 'mp-cargo-fee-bulk-tab__rules-paper',
    bulkTabUploadWrap: 'mp-cargo-fee-bulk-tab__upload-wrap',
    bulkTabStatusRow: 'mp-cargo-fee-bulk-tab__status-row',
    bulkTabFailedSection: 'mp-cargo-fee-bulk-tab__failed-section',
    bulkTabFailedTitle: 'mp-cargo-fee-bulk-tab__failed-title',
    bulkTabFailedGridWrap: 'mp-cargo-fee-bulk-tab__failed-grid-wrap',
} as const;

export const mpcfmCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
